import { useQuery } from "@tanstack/react-query"
import { profile } from  '@shared/api/services'

export const useAllInstruments = () => {
	return useQuery({
		queryKey: ['instruments'],
		queryFn: () => profile.getAllInstruments(),
		select: (data) => data.data
})
}